var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer mt15"},[_c('div',{staticClass:"layout-footer-warp"},[_c('div',{staticClass:"ivu-global-footer i-copyright"},[_c('div',{staticClass:"ivu-global-footer-copyright"},[_vm._v(" Copyright © 妍妍客户管理系统 ")]),_c('div',{staticClass:"ivu-global-footer-links acea-row row-center-wrapper"})])])])
}]

export { render, staticRenderFns }